import React, { useState } from 'react'
import { HardDrive } from 'lucide-react'
import styles from './AdminDashboard.module.scss'
import QueueManager from './components/QueueManager'
import Artifacts from '../Artifacts/Artifacts'
import ElasticsearchManager from './components/ElasticsearchManager'
import PublishRunsManager from './components/PublishRunsManager'

type TabType = 'queues' | 'publishRuns' | 'artifacts' | 'elasticsearch'

const AdminDashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState<TabType>('queues')

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div className={styles.titleSection}>
          <h1>Operations Dashboard</h1>
          <span className={styles.subtitle}>System maintenance and management</span>
        </div>
      </div>

      <div className={styles.tabBar}>
        <button
          className={`${styles.tab} ${activeTab === 'queues' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('queues')}>
          <span className={styles.tabIcon}>📬</span>
          Queues
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'publishRuns' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('publishRuns')}>
          <span className={styles.tabIcon}>🔔</span>
          Publish Runs
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'artifacts' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('artifacts')}>
          <span className={styles.tabIcon}>
            <HardDrive size={16} />
          </span>
          Artifacts
        </button>
        <button
          className={`${styles.tab} ${activeTab === 'elasticsearch' ? styles.activeTab : ''}`}
          onClick={() => setActiveTab('elasticsearch')}>
          <span className={styles.tabIcon}>🔍</span>
          Elasticsearch
        </button>
      </div>

      <div className={styles.content}>
        {activeTab === 'queues' && <QueueManager />}
        {activeTab === 'publishRuns' && <PublishRunsManager />}
        {activeTab === 'artifacts' && <Artifacts />}
        {activeTab === 'elasticsearch' && <ElasticsearchManager />}
      </div>
    </div>
  )
}

export default AdminDashboard
